import React, { useState } from 'react';

// Import images
import event1 from '../img/envision/qualityimges/qqq.JPG';
import event2 from '../img/envision/newsandevents/cards/shutterstock_2137436129.jpg';
import newsupdate from '../img/envision/newsandevents/cards/shutterstock_2385198387.jpg';
import event4 from '../img/envision/newsandevents/Banner Network Managment.webp';
import event5 from '../img/envision/newsandevents/Q2 FY24  RESULTS - Web Banner - 1920x1080px.webp';
import event6 from '../img/envision/newsandevents/shutterstock_1927651358.webp';

const Newsandeventscards = () => {
  return (
    <div style={styles.app}>
      <div style={styles.cardContainer}>
        {/* First Card */}
        <Card
          image={event1}
          date="January 13"
          description="Envision and Allegro MicroSystems Partner to Drive Innovation in Magnetic Sensors & Power Semiconductors"
        />

        {/* Second Card */}
        <Card
          image={event2}
          date="March 19"
          description="Envision Announces Q1 FY25 Results, Pipeline for the Year Remains Strong"
        />

        {/* Third Card */}
        <Card
          image={event4}
          date="August 28"
          description="Envision Announces Q2FY25 Results; Net Profit Rises 2%"
        />

         {/* fourth Card */}
         <Card
          image={event5}
          date="August 28"
          description="Envision Announces Q2FY25 Results; Net Profit Rises 2%"
        />

         {/* fifth Card */}
         <Card
          image={event6}
          date="August 28"
          description="Envision Announces Q2FY25 Results; Net Profit Rises 2%"
        />

         {/* sixth Card */}
         <Card
          image={newsupdate}
          date="August 28"
          description="Envision Announces Q2FY25 Results; Net Profit Rises 2%"
        />
      </div>
    </div>
  );
};

// Card Component to handle hover effect
const Card = ({ image, date, description }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{ ...styles.card, ...isHovered ? styles.cardHovered : {} }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img src={image} alt="Event" style={styles.cardImage} />
      <h3 style={styles.cardTitle}>{date}</h3>
      <CardDescription description={description} />
    </div>
  );
};

// Card Description Component to display the full content
const CardDescription = ({ description }) => {
  return <p style={styles.cardDescription}>{description}</p>;
};

// Styles for the card components
const styles = {
  app: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#fff',
    // minHeight: '100vh',
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },

  cardHovered: {
    transform: 'scale(1.05)', // Zoom-in effect
    backgroundColor: '#f5f5f5', // Change background color on hover
  },
  card: {
    width: '350px',
    height: '400px', // Set fixed height for the card to accommodate the image and content
    border: '1px solid #ddd',
    borderRadius: '10px',
    padding: '0', // Remove padding to avoid extra space inside the card
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    margin: '15px',
    textAlign: 'center',
    backgroundColor: '#fff',
    transition: 'transform 0.3s, background-color 0.3s', // Smooth transition for hover effects
    overflow: 'hidden', // Ensures content stays within the card bounds
  },
  
  cardImage: {
    width: '100%', // Ensures the image stretches to fill the card's width
    height: '250px', // Defines a consistent height for the image
    objectFit: 'cover', // Ensures the image fills the space without distortion
    borderTopLeftRadius: '10px', // Matches card's border radius
    borderTopRightRadius: '10px',
    display: 'block', // Removes inline spacing
  },
  

  cardTitle: {
    fontSize: '1.5em',
    margin: '10px 0',
  },
  cardDescription: {
    fontSize: '1em',
    margin: '10px 18px',
    textAlign: 'justify'
  },
};

export default Newsandeventscards;
